import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft, FaCreditCard, FaWallet, FaPlus, FaEdit, FaTrash } from 'react-icons/fa';

const PaymentMethods = () => {
  const [methods, setMethods] = useState([
    { id: 1, type: 'Credit Card', last4: '1234', expiry: '12/26', default: true },
    { id: 2, type: 'Debit Card', last4: '9012', expiry: '08/25', default: false },
    { id: 3, type: 'UPI', id: 'john.doe@paytm', default: false },
  ]);

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this payment method?')) {
      setMethods(methods.filter(m => m.id !== id));
    }
  };

  return (
    <motion.div 
      className="py-4 max-w-2xl mx-auto"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="page-header">
        <Link to="/profile" className="back-btn">
          <FaArrowLeft /> Back
        </Link>
        <h1 className="page-title">💳 Payment Methods</h1>
      </div>

      <button className="w-full mb-6 py-3 px-4 rounded-xl border-2 border-dashed border-primary text-primary font-semibold hover:bg-primary hover:text-white transition-all duration-300 flex items-center justify-center gap-2">
        <FaPlus /> Add Payment Method
      </button>

      <div className="space-y-4">
        {methods.map((method) => (
          <motion.div
            key={method.id}
            className="card"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3">
                {method.type === 'UPI' ? <FaWallet className="text-primary mt-1" /> : <FaCreditCard className="text-primary mt-1" />}
                <div>
                  <h4 className="font-semibold text-[var(--text)]">{method.type}</h4>
                  {method.type === 'UPI' ? (
                    <p className="text-sm text-[var(--text-secondary)]">{method.id}</p>
                  ) : (
                    <p className="text-sm text-[var(--text-secondary)]">•••• {method.last4} • Expires {method.expiry}</p>
                  )}
                  {method.default && (
                    <span className="badge badge-success text-xs mt-1">✅ Default</span>
                  )}
                </div>
              </div>
              <div className="flex gap-2">
                <button className="text-[var(--text-secondary)] hover:text-primary transition-colors">
                  <FaEdit />
                </button>
                <button onClick={() => handleDelete(method.id)} className="text-[var(--text-secondary)] hover:text-danger transition-colors">
                  <FaTrash />
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default PaymentMethods;